<template>
  <div :style="styles" class="popup-field">
    <div v-if="open" ref="editorPopover" :class="classes" class="editable-field-container">
      <SpinnerAudioLoader :loading="loading" />

      <div class="editable-field-container__header">
        <h3 class="editable-field-container__title">{{ title }}</h3>
      </div>

      <div class="editable-field-container__content" style="width: 100%">
        <div class="row no-wrap q-pa-sm">
          <slot name="content" />

          <div class="actions">
            <q-btn color="tertiary" outline @click="$emit('save')">
              <i class="fas fa-save" />
            </q-btn>

            <q-btn flat text-color="black" @click="$emit('close')">
              <i class="fas fa-times" />
            </q-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerAudioLoader from '@/reusable/base-components/SpinnerAudioLoader'

export default {
  components: {
    SpinnerAudioLoader
  },
  props: {
    position: {
      default: 'right',
      validator: value => ['left', 'left-end', 'right'].includes(value)
    },
    size: {
      default: 'small',
      validator: value => ['small', 'big'].includes(value)
    },
    positionedHigh: Boolean,
    buttonPosition: {
      default: 'right',
      validator: value => ['right', 'down'].includes(value)
    },
    title: {
      type: String,
      required: true
    },
    styles: Object,
    open: Boolean,
    loading: Boolean
  },

  computed: {
    classes() {
      let classes = []
      classes.push(`editable-field-container--${this.position}`)
      classes.push(`editable-field-container--${this.size}`)
      if (this.buttonPosition === 'down') classes.push('editable-field-container--button-down')
      if (this.positionedHigh) classes.push('positioned-high')
      return classes
    }
  }
}
</script>

<style lang="stylus" scoped>
.popup-field {
  position relative
  z-index 11

  .actions {
    display grid
    grid-auto-flow column
    align-items center
    gap 2px
    margin-left 5px
  }
}
</style>
